// saga/sportsBanner.js
import { put, takeEvery } from "redux-saga/effects";

import {
  getSportsBannerFailure,
  getSportsBannerStart,
  getSportsBannerSuccess
} from "../../redux/sportsBanner";
import sportsBannerService from "../../../services/sportsBanner";

function* sportsBannerWatcher() {
  yield takeEvery(getSportsBannerStart.type, sportsBannerWorker);
}

function* sportsBannerWorker(action) {
  try {
    const payload = action.payload;
    const { data, error } =
      yield sportsBannerService.getSportsBannerData(payload);
    if (!error) {
      yield put(getSportsBannerSuccess(data));
    } else {
      yield put(getSportsBannerFailure(error));
    }
  } catch (err) {
    yield put(getSportsBannerFailure(err));
  }
}

export default sportsBannerWatcher;
